import React, { PropsWithChildren } from 'react';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import { blue } from "./constants";


const SaaSPlatform: React.FC<{

}> = ({  }) => {

    const url = 'www.restapicms.com';

    return (
        <Box
            sx={{
                fontSize: '0.9em',
                pb: 2,
                position: 'relative',
            }}
        >

            <h4 style={{
                margin: 0
            }}>
                {'Founder & Lead Engineer'}
            </h4>

            <p style={{ margin: 0 }}>
                <a href={`http://${url}`} style={{ color: blue }}>{`http://${url}`}</a> <span>(code available upon request)</span>
            </p>

            <h4 style={{
                marginTop: 4,
                marginBottom: 2
            }}>
                {'Java • Spring Boot • React • Multi-tenant SaaS • OpenAPI • Docker • AWS'}
            </h4>

            <p style={{
                marginTop: 1,
                marginBottom: 4
            }}>
                {'Developer platform that automatically generates backend services (database schema, REST APIs, and admin console) from user-defined configuration. '}
            </p>

            <p style={{
                marginTop: 0
            }}>
                {'Platform dynamically provisions backend services using Docker containers and reverse-proxy routing.'}
            </p>

            <h4 style={{
                margin: 0
            }}>
                {'Key contributions'}
            </h4>

            <ul
                style={{
                    listStylePosition: 'inside',
                    padding: 0,
                    margin: 0,
                    marginTop: 8
                }}
            >
                <li>{'Architected and built a multi-tenant SaaS platform enabling users to create backend services without writing server code.'}</li>
                <li>{'Implemented automatic backend generation including database schema, REST endpoints, OpenAPI documentation, and administrative UI.'}</li>
                <li>{'Implemented service routing and isolation for dynamically provisioned backend instances using Docker containers and Nginx reverse proxy.'}</li>
                <li>{'Developed an advanced query engine allowing complex filtering criteria through UI.'}</li>
                <li>{'Built data visualization components using D3.js.'}</li>
                <li>{'Implemented role-based access control using Spring Security and JWT.'}</li>
                <li>{'Deployed production infrastructure on AWS EC2 with Linux services.'}</li>
            </ul>
        </Box>
    )
}

export { SaaSPlatform };